import { forwardRef, type Ref, type SVGProps } from "react";
const IconHeartOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M27.66 6.19a7.85 7.85 0 0 0-11 .13L16 7l-.65-.66a7.85 7.85 0 0 0-11-.13 8.23 8.23 0 0 0 .09 11.59l.42.42L15.29 28.7a1 1 0 0 0 1.42 0l10.44-10.5.42-.42a8.23 8.23 0 0 0 .09-11.59m-1.42 10.06-.52.52L16 26.55l-9.72-9.78-.52-.52A6.15 6.15 0 0 1 4 13.19a5.91 5.91 0 0 1 1.62-5.43 5.81 5.81 0 0 1 4.67-1.71 6 6 0 0 1 3.78 1.87l.5.5 1.08 1.08a.5.5 0 0 0 .7 0l1.08-1.08.5-.5a6 6 0 0 1 3.78-1.87 5.81 5.81 0 0 1 4.67 1.71A5.91 5.91 0 0 1 28 13.19a6.15 6.15 0 0 1-1.76 3.06" />
  </svg>
);
const ForwardRef = forwardRef(IconHeartOutlineSVG);
ForwardRef.displayName = "IconHeartOutline";
export { ForwardRef as IconHeartOutline };
